import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type TabsHeadingProps = ComponentProps<"span">

/**
 * Captions a run of related tabs in a sidebar strip — "Billing" over the
 * Fenerum boards, "Catalog" over the licenses and packages. Decoration like
 * Tabs.Separator: not focusable, invisible to the tab list's roving focus;
 * the tab names carry the meaning on their own.
 */
function TabsHeading(props: TabsHeadingProps) {
  const { className, ...spanProps } = props

  return (
    <span
      aria-hidden
      className={cn("ui-tabs-heading", className)}
      {...spanProps}
    />
  )
}

export default TabsHeading
